// components/ProtectedRoute.js
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import SubscriptionService from "app/services/SubscriptionServices";
import { useEffect, useState } from 'react';

const ProtectedRoute = ({ children }) => { 
    const [hasActiveAccount, setHasActiveAccount] = useState(null); // or from context/state
    const [isChecking, setIsChecking] = useState(true); // or from context/state
    const [subscriptions, setSubscriptions] = useState([]);
    const subscriptionService = SubscriptionService();
    const fetchData = async () => {
        try {
            const subs = await subscriptionService.getSubscriptions();
            setSubscriptions(subs);
            subs.forEach(sub => {
            if (sub.balance > 0) {
                localStorage.setItem('UseActiveAccount', sub.id);
                setHasActiveAccount(true);
            }
            setIsChecking(false);
        });
    } catch (err) {
            setIsChecking(false);
            setSubscriptions([]);
        }
    };
    useEffect(() => {
       fetchData();
    },[]);
    
    if (isChecking) return <div>Loading...</div>; // Or a spinner
    return hasActiveAccount ? children : <Navigate to="/my-account" />;
  //const hasActiveAccount = localStorage.getItem('hasActiveAccount'); // or from context/state
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
